import { useState } from 'react'
import { ApiErrorResponse } from '../models/Common'

const useErrorHandler = () => {
  const [userErrors, setUserErrors] = useState<string[]>([])

  const stringifyErrors = (errors: any, fieldMapping: Map<string, string>) => {
    const keys = Object.keys(errors)
    const formatted = keys?.map((key) => {
      const error = fieldMapping.get(key)
      return `${error}: cannot be empty, it is required.`
    })
    setUserErrors(formatted)
  }

  const addErrors = (errors: string[]) => {
    setUserErrors(errors)
  }

  const handleErrors = (error: any) => {
    if (error === undefined) {
      return
    }

    let errors = []
    if (error?.errors === undefined) {
      errors.push(error)
    } else {
      const response = new ApiErrorResponse(error)
      if (response.errors) {
        const entries = Object.entries(response.errors)
        let formattedErrors: string[] = []

        for (const entry of entries) {
          const messages: string[] = entry[1]

          for (const msg of messages) {
            formattedErrors = [...formattedErrors, `${msg}`]
          }
        }
        errors = formattedErrors
      } else {
        errors.push(response.detail)
      }
    }
    setUserErrors(errors)
  }

  const clearErrors = () => {
    setUserErrors([])
  }

  return [
    userErrors,
    addErrors,
    handleErrors,
    stringifyErrors,
    clearErrors,
  ] as const
}

export default useErrorHandler
